import { Injectable, signal } from '@angular/core';

/**
 * Web girişte kurum gösterimi (2026-10-19): giriş sonrası üst çubukta yalnız kurum adı. Ad GET /v2/Org/Settings'ten
 * (OrgMetaService.reload, ayarlar sayfası) yazılır; org oturumu bitince ya da org düzeninden çıkılınca silinir.
 * Bağımlılıksızdır: üst çubuk (her yüzeyde) org servis zincirini yüklemeden okur.
 */
@Injectable({ providedIn: 'root' })
export class OrgNameStore {
  private readonly nameSig = signal<string | null>(null);
  readonly name = this.nameSig.asReadonly();

  set(name: string | null | undefined): void {
    const n = name?.trim();
    this.nameSig.set(n ? n : null);
  }

  clear(): void { this.nameSig.set(null); }
}
